<template>
    <div v-if="paciente">
        <az-float-panel
            classe="left"
            icon="fas fa-id-badge"
            :action="perfil"
            :sync="sync"
        >
            <div v-if="conteudo && conteudo.id_pessoa == paciente.id_pessoa">
                <div>{{ paciente.st_nome }}</div>
                <small>
                    {{ conteudo.paciente_unidade.plano.search }}, 
                    {{ conteudo.cadastro.sexo }}
                </small>

                <div class="small" v-if="conteudo.cadastro.dt_nascimento">
                    Dt. Nasc: {{ $util.getFormatDate(conteudo.cadastro.dt_nascimento) }}
                    <span class="ml-3">{{ conteudo.cadastro.idade }}</span>
                </div>

                <div v-else-if="conteudo.cadastro.idade">
                    {{ conteudo.cadastro.idade }}
                </div>

                <div v-if="conteudo.logo && conteudo.logo.arquivo">
                    <img :src="conteudo.logo.arquivo.temporary_url" class="img-fluid img-thumbnail" style="max-width: 200px; max-height: 130px;">
                </div>
                
                <div v-for="(tel, it) in telefones" :key="it">
                    <i class="fas fa-phone fa-fw mr-1" v-if="tel.telefone.ch_tipo_telefone == 'R'"></i>
                    <i class="fas fa-mobile-alt fa-fw mr-1" v-if="tel.telefone.ch_tipo_telefone == 'M'"></i>
                    {{ telefone(tel.telefone) }}
                </div>
                <div v-if="conteudo.cadastro.st_email"> 
                    <i class="far fa-envelope fa-fw mr-1"></i>
                    {{ conteudo.cadastro.st_email }}
                </div>
            </div>
            <div v-else>
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </az-float-panel>
    </div>
</template>

<script>
import AzFloatPanel from '../util/AzFloatPanel.vue';

export default {

    data () { 
        return { 
            conteudo: null,
            abrirOnLoad: false, 
        }
    },

    props: ['paciente'],

    components: { 
        AzFloatPanel
    },

    computed: { 
      telefones: function () { 
        return ( !this.conteudo.cadastro || !this.conteudo.cadastro.telefone_cadastros ) 
            ? [] 
            : this.conteudo.cadastro.telefone_cadastros.filter((item) => { 
                    return item.telefone.st_numero.trim ();
                });
      }
    },

    methods: { 

        telefone (telefone) { 

            let numb = telefone.st_numero.match(/\d/g);

            if ( !numb )
                return;

            numb = numb.join("");

            let textoAjustado = "";

            if ( numb.length == 8 ) {
                const parte1 = numb.slice(0,4);
                const parte2 = numb.slice(4,8);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`;
            } else if ( numb.length == 9 ) {        
                const parte1 = numb.slice(0,5);
                const parte2 = numb.slice(5,9);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`;
            } else { 
                textoAjustado = "(" + numb.slice(0,2) + ") ";
                if(numb.length == 11) {
                    const parte1 = numb.slice(2,7);
                    const parte2 = numb.slice(7,11);
                    textoAjustado = textoAjustado + `${parte1}-${parte2}`        
                } else {
                    const parte1 = numb.slice(2,6);
                    const parte2 = numb.slice(6,10);
                    textoAjustado = textoAjustado + `${parte1}-${parte2}`
                }
            }

            return textoAjustado;
        },

        perfil () { 
            if ( this.conteudo && this.conteudo.id_pessoa == this.paciente.id_pessoa ) { 
                this.$root.perfil(this.conteudo);
                this.abrirOnLoad = false;
            } else { 
                this.abrirOnLoad = true;
            }
        },

        sync () { 
            if ( !this.conteudo || this.conteudo.id_pessoa != this.paciente.id_pessoa ) { 

                let query = { q: [ 
                    {
                        name: 'pacientes.show',
                        id: 'paciente',
                        parms: { 
                            id: this.paciente.id_pessoa,
                            with:[
                                'logo.arquivo',
                            ],
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.paciente.status == 200 ) { 
                            this.conteudo = res.data.paciente.data;
                            if ( this.abrirOnLoad )
                                this.perfil();
                        }
                    });

            }

        }
    }
}
</script>